module.exports = __webpack_public_path__ + "img/mono_3.5caf6002.png";